import app, { Component } from 'apprun';
import { isStringEqual, isValidElement } from './utils';
import { obApi } from './api';

//import SRegionCOB_RLP2RLPComponentomponent from './ob-rlp2rlp';
import OB_RLP2RLPComponent from './ob-rlp2rlp';
import OB_NewConversionComponent from './ob-new-conversion';

export default class OnboardingComponent extends Component {
  state = async () => {
    const onboardingTypeOptions = await obApi.getOnboardingTypeOptions();
    onboardingTypeOptions.forEach(p => (p.value = p.name));
    return { onboardingTypeOptions, obType: '1' };
  };

  //  ddlComp = ({ id, optoins, objWithRetAttrib, retAttrib}) => {
  ddlComp = ({ ddlCompState }) => {
    return (
      <div>
        <select
          id={ddlCompState.id}
          class="form-control"
          oninput={e => (ddlCompState.objWithRetAttrib[ddlCompState.retAttrib] = e.target.value)}>
          <option value="-1">[Select]</option>
          {ddlCompState.optoins.map(p => (
            <option
              value={p.id}
              selected={isStringEqual( p.id, ddlCompState?.objWithRetAttrib?.[ddlCompState.retAttrib])?'selected': null}>
              {p.value}
            </option>
          ))}
        </select>
        <div id={ddlCompState.id + 'ErrMsg'} class="text-danger, row"></div>
      </div>
    );
  };

  view = (state) => {
    return (
      <div style={{ width: '300px' }}>
        <h3> ONBOARDING </h3>
        <h2> Select Onboarding Type </h2>
        <br />

        <div class="row">
          <span class="form-text">What type of onboard will this be?</span>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <this.ddlComp
              ddlCompState={{
                id: 'obType',
                optoins: state.onboardingTypeOptions,
                objWithRetAttrib: state,
                retAttrib: 'obType'
              }}
            />
          </div>
        </div>
        <br />
        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={e => this.run('continue', e)}>
            Continue
          </a>
        </div>
      </div>
    );
  };

  update = {
    continue: (state) => {
      if (isValidElement('obType', 'Int-1')) {
        switch (state.obType) {
        case '1':
          app.run('#add-panel', {
            id: 'obRlp2Rlp',
            title: 'Onboarding - Select Locations',
            Component: OB_RLP2RLPComponent,
            level: 2,
            state: { caller: this }
          });
          break;
        case '2':
          app.run('#add-panel', {
            id: 'obNewConversion',
            title: 'New Conversoin',
            Component: OB_NewConversionComponent,
            level: 2,
            state: { caller: this }
          });
          break;
        default:
        }
        return state;
      }
    },

    'sub-panel-cancelled': () => {
      app.run('#clear-panel', 'obNewConversion');
    }
  };
}
